/**
 * Client-side source of truth for whether non-essential analytics may run.
 * Mirrors the server policy (game/utils/analytics/consentPolicy.js): opt-in by default,
 * and Global Privacy Control is always honored as a deny signal.
 *
 * The AUTHORITATIVE record lives in Convex (marketingConsent). This is the fast local
 * cache the PostHog loader reads so we never call analytics before a grant. The consent
 * gate writes the decision here when the user submits.
 */
let MoonfallConsent;

(function () {
  "use strict";

  var STORAGE_KEY = "moonfall.analyticsConsent"; // 'granted' | 'denied'
  var listeners = [];

  function gpcDenied() {
    try {
      return navigator.globalPrivacyControl === true;
    } catch (_) {
      return false;
    }
  }

  function storedChoice() {
    try {
      var v = window.localStorage.getItem(STORAGE_KEY);
      return v === "granted" || v === "denied" ? v : undefined;
    } catch (_) {
      return undefined;
    }
  }

  // GPC is an active deny signal. A stored grant remains on file, but collection stays
  // disabled while the browser sends GPC and resumes only if that signal is removed.
  function analyticsAllowed() {
    return !gpcDenied() && storedChoice() === "granted";
  }

  function setAnalyticsConsent(granted) {
    try {
      window.localStorage.setItem(STORAGE_KEY, granted ? "granted" : "denied");
    } catch (_) {
      // localStorage unavailable (private mode); decision is still authoritative in Convex.
    }
    var allowed = analyticsAllowed();
    listeners.forEach(function (fn) {
      try {
        fn(allowed);
      } catch (_) {
        // a broken listener must not break consent propagation
      }
    });
    return allowed;
  }

  function onChange(fn) {
    if (typeof fn === "function") listeners.push(fn);
  }

  MoonfallConsent = {
    analyticsAllowed: analyticsAllowed,
    setAnalyticsConsent: setAnalyticsConsent,
    onChange: onChange,
    gpcDenied: gpcDenied,
  };
})();

export { MoonfallConsent };
